import { Box, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { pink } from "@mui/material/colors";
import React from "react";

const RadioButtons = () => {
	return (
		<Box>
			<Grid container spacing={3}>
				<Grid item>
					<FormControl>
						<FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel>
						<RadioGroup
							aria-labelledby="demo-radio-buttons-group-label"
							defaultValue="female"
							name="radio-buttons-group"
						>
							<FormControlLabel value="female" control={<Radio/>} label="Female"/>
							<FormControlLabel value="male" control={<Radio/>} label="Male"/>
							<FormControlLabel value="other" control={<Radio/>} label="Other"/>
						</RadioGroup>
					</FormControl>
				</Grid>
				<Grid item>
					<FormControl>
						<FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
						<RadioGroup
							row
							aria-labelledby="demo-row-radio-buttons-group-label"
							name="row-radio-buttons-group"
						>
							<FormControlLabel value="female" control={<Radio/>} label="Female"/>
							<FormControlLabel value="male" control={<Radio/>} label="Male"/>
							<FormControlLabel value="other" control={<Radio/>} label="Other"/>
							<FormControlLabel
								value="disabled"
								disabled
								control={<Radio/>}
								label="other"
							/>
						</RadioGroup>
					</FormControl>
				</Grid>
				<Grid item>
					<div>
						<Radio size="small"/>
						<Radio/>
						<Radio
							
							sx={{
								'& .MuiSvgIcon-root': {
									fontSize: 28,
								},
							}}
						/>
						<Radio/>
						<Radio color="secondary"/>
						<Radio color="success"/>
						<Radio color="default"/>
						<Radio
							sx={{
								color: pink[800],
								'&.Mui-checked': {
									color: pink[600],
								},
							}}
						/>
					</div>
				</Grid>
				<Grid item>
					<FormControl>
						<FormLabel id="demo-form-control-label-placement">Label placement</FormLabel>
						<RadioGroup
							row
							aria-labelledby="demo-form-control-label-placement"
							name="position"
							defaultValue="top"
						>
							<FormControlLabel
								value="top"
								control={<Radio/>}
								label="Top"
								labelPlacement="top"
							/>
							<FormControlLabel
								value="start"
								control={<Radio/>}
								label="Start"
								labelPlacement="start"
							/>
							<FormControlLabel
								value="bottom"
								control={<Radio/>}
								label="Bottom"
								labelPlacement="bottom"
							/>
							<FormControlLabel value="end" control={<Radio/>} label="End"/>
						</RadioGroup>
					</FormControl>
				</Grid>
			</Grid>
		</Box>
	)
}

export default RadioButtons;